module.exports = "http://cdn.realive.com.ua/src/views/player/oressale/assets/images/ore_coal.png";